/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeApplePayProvisioning} from '../api'

export const useMutationCompleteApplePayProvisioning = createReactQueryMutationHook('completeApplePayProvisioning', completeApplePayProvisioning)
